import {ref} from "vue"

export type AlertType = "success" | "error" | "warning" | "info"

export interface AlertItem {
    id: number
    message: string
    type: AlertType
}

const alerts = ref<AlertItem[]>([])
let idCounter = 0

function show(message: string, type: AlertType = "error", duration = 3000) {
    const id = idCounter++

    if (alerts.value.length >= 3) {
        alerts.value.shift()
    }

    alerts.value.push({id, message, type})

    setTimeout(() => {
        remove(id)
    }, duration)
}

function remove(id: number) {
    alerts.value = alerts.value.filter(a => a.id !== id)
}

export function useAlert() {
    return {
        alerts,
        show,
        remove
    }
}
